import axios from 'axios';

import { observer } from "mobx-react-lite";
import { Button, Header, Label, Segment, Icon } from "semantic-ui-react";

import { Form, Formik, Field, useFormik } from "formik";
import Swal from "sweetalert2";
import * as Yup from "yup";
import ReactToPrint from "react-to-print";
import React, { useEffect, useState, useRef } from "react";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import MyTextInput, { MyTextInputConvD, MyTextInputConv, MyTextAreatConv, MyTextInputFechas } from "../../../app/common/form/MyTextInput";

import { calculoFechas } from "../../Portafolio/helpers/calculoFechas";
import Container from 'react-bootstrap/Container';
import Image from 'react-bootstrap/Image';
import Modal from 'react-bootstrap/Modal';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

let idNUM: number;
let CType: string;
let insti: any;

interface IFileData {
    file: any;
    name: string;
    type: string;
    description: string;
}

interface IFormData {
    id: number;
    ContentType: string;
    files: IFileData[];
}

export default observer(function SimpleFileUploadForm(

    PI: {
        show: any,
        onHide: any,
        pinst: any,
        ctype: string
    }) {
        
        const perfilImg = process.env.REACT_APP_API_URL + `/Storage`;
        CType = PI.ctype;
        idNUM = PI.pinst;

    // const [selectedFile, setSelectedFile] = useState<File | null>(null);

    // const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    //     const files = event.target.files;
    //     if (files && files.length > 0) {
    //         setSelectedFile(files[0]);
    //     }
    // };

    // const handleSubmit = async (event: React.FormEvent) => {
    //     event.preventDefault();

    //     if (!selectedFile) {
    //         console.log('No se ha seleccionado ningún archivo');
    //         return;
    //     }

    //     const formData = new FormData();
    //     formData.append('file', selectedFile);
    //     formData.append('Id', PI.pinst);
    //     formData.append('ContentType', PI.ctype);

    //     try {
    //         const response = await axios.post(perfilImg, formData, {
    //             headers: {
    //                 'Content-Type': 'multipart/form-data',
    //             },
    //         });

    //         console.log('Respuesta del servidor:', response.data);
    //     } catch (error) {
    //         console.error('Error al enviar el archivo:', error);
    //     }
    // };

    const [file, setFile] = useState<File | null>(null);
    const [description, setDescription] = useState("");
    const [formData, setFormData] = useState<IFormData>({ id: +idNUM, files: [], ContentType: CType });
    const [selectedFiles, setSelectedFiles] = useState<File[]>([]);

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files) {
            setSelectedFiles([...selectedFiles, event.target.files[0]]);
            setFile(event.target.files[0]);
        }
    };

    const handleDescriptionChanges = (
        event: React.ChangeEvent<HTMLTextAreaElement>
    ) => {
        setDescription(event.target.value);
    };

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        if (file && description) {
            const fileData: IFileData = {
                file: file,
                name: file.name,
                type: file.type,
                description,
            };
            setFormData({
                ...formData,
                files: [...formData.files, fileData],
            });
            setDescription("Imagen Institucional");
            setFile(null);
        }
    };

    const handleSend = () => {
        const formDataToSend = new FormData();
        formDataToSend.append("id", idNUM.toString());
        formDataToSend.append("ContentType", CType);
        formData.files.forEach((fileData, index) => {
            formDataToSend.append(`Files[${index}].File`, fileData.file);
            formDataToSend.append(
                `Files[${index}].Description`,
                fileData.description
            );
        });
        fetch(perfilImg, {
            method: "POST",
            body: formDataToSend,
        }).then(function (r) {
            if (r.status == 200) {
                return insti ? ExitValInsti() : ExitVal();
            } else { ExitMsjError() }
        });
    };

    function ExitVal() {
        Swal.fire({
            position: "center",
            showCloseButton: true,
            title: 'Archivos creados exitosamente',
            text: "Tu solicitud fue creada exitosamente, y adjuntaste los primeros archivos, ahora te sugerimos crear el código",
            icon: 'success',

            showConfirmButton: true,
            confirmButtonText: 'Aceptar',
            confirmButtonAriaLabel: "confirm-button",

        }).then((result) => {
            if (result.isConfirmed) {
                window.location.reload()
                // window.location.href = `/cargapagos/crear-convenio`;
            } else if (result.isDismissed) {
                window.location.reload()
            }
        })
    };

    function ExitValInsti() {
        Swal.fire({
            position: "center",
            showCloseButton: true,
            title: 'Archivos creados exitosamente',
            text: "Tu solicitud fue creada y adjuntaste los primeros archivos del proceso exitosamente.",
            icon: 'success',

            showConfirmButton: true,
            confirmButtonText: 'Aceptar',
            confirmButtonAriaLabel: "confirm-button",

        }).then((result) => {
            if (result.isConfirmed) {
                window.location.reload()
            } else if (result.isDismissed) {
                window.location.reload()
            }
        })
    };

    function ExitMsjError() {
        Swal.fire({
            position: "center",
            icon: "warning",
            title: "Error",
            text: 'Ha ocurrido un error en la actualización, por favor verifica que la informacion sea correcta e intenta de nuevo.',
            showConfirmButton: false,
            timer: 3500,
        });
    };

    return (

        <>

            <Modal
                {...PI}
                size="lg"
                className="modal-add-dep-content"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >

                <Modal.Header closeButton >
                    <Modal.Title id="contained-modal-title-vcenter">
                        Carga de archivo
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Container className="modal-sol-detalle">
                        <Row className="files-list-area">

                            {/* <form onSubmit={handleSubmit}>
                                <div>
                                    <input type="file" onChange={handleFileChange} />
                                </div>
                                <button type="submit">Subir Imagen</button>
                            </form> */}

                            <form onSubmit={handleSubmit}>
                                <Row className="input-file-select">
                                    <input
                                        className="file-upload-custom"
                                        id="file-upload"
                                        type="file"
                                        onChange={handleFileChange}
                                    />
                                </Row>

                                <Row className="descripcion-file-form">
                                    <label htmlFor="description-input">Descripción:</label>
                                    <textarea
                                        id="description-input"
                                        rows={4}
                                        value={description}
                                        onChange={handleDescriptionChanges}
                                    />
                                </Row>

                                <Row className="buttons-form-upload upload-files">
                                    <Button className=" button-green" type="submit" animated>
                                        <Button.Content visible> Cargar archivos </Button.Content>
                                        <Button.Content hidden>
                                            <Icon name="file pdf outline" />
                                        </Button.Content>
                                    </Button>
                                </Row>
                            </form>

                        </Row>
                    </Container>
                </Modal.Body>

                <Modal.Footer>
                    <Row className="buttons-form-upload send-file">
                        <Button className="primary" animated onClick={handleSend}>
                            <Button.Content visible>Subir archivos</Button.Content>
                            <Button.Content hidden>
                                <Icon name="send" />
                            </Button.Content>
                        </Button>
                    </Row>
                </Modal.Footer>

            </Modal>

        </>

    );

})


// const FileUploadForms: React.FC = () => {
//   const [selectedFile, setSelectedFile] = useState<File | null>(null);

//   const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
//     const files = event.target.files;
//     if (files && files.length > 0) {
//       setSelectedFile(files[0]);
//     }
//   };

//   const handleSubmit = async (event: React.FormEvent) => {
//     event.preventDefault();

//     if (!selectedFile) {
//       console.log('No se ha seleccionado ningún archivo');
//       return;
//     }

//     const formData = new FormData();
//     formData.append('file', selectedFile);

//     try {
//       const response = await axios.post('URL_DE_TU_API', formData, {
//         headers: {
//           'Content-Type': 'multipart/form-data',
//         },
//       });

//       console.log('Respuesta del servidor:', response.data);
//     } catch (error) {
//       console.error('Error al enviar el archivo:', error);
//     }
//   };

//   return (
//     <form onSubmit={handleSubmit}>
//       <div>
//         <input type="file" onChange={handleFileChange} />
//       </div>
//       <button type="submit">Subir Imagen</button>
//     </form>
//   );

// };

// export default FileUploadForms;